import autosize from 'autosize';
import Choices from 'choices.js';
import { DataTable } from "simple-datatables";
import domready from 'domready';
import Utilities from '@js/src/Utilities';
import Velocity from 'velocity-animate';

domready(function() {
    const isFrontend = document.getElementById('fe-body') !== null;
    const isBackend = document.getElementById('admin-body') !== null;

    // Autosize textareas that request it
    autosize(document.querySelectorAll('textarea.autosize'));

    // Add a choices dropdown automatically for simple replacements
    if (document.querySelectorAll('select.choices-default').length > 0) {
        const choices = new Choices('select.choices-default');
    }

    // Backend actions only...
    if (isBackend) {
        // Set all forms to autocomplete off
        document.querySelectorAll('form').forEach(e => {
            e.setAttribute('autocomplete', 'off');
        });

        // Collect CSS files to use in our CKeditor
        let css = [];
        document.head.querySelectorAll('link[rel="stylesheet"][data-site]').forEach(function(e) {
            css.push(e.href);
        });

        // Data tables
        let dataTables = document.querySelectorAll('table.table-datatables-generic');
        dataTables.forEach(dt => {
            let options = {
                'perPage': dt.getAttribute('data-page-10') ? 10 : 25,
                'perPageSelect': false,
            };
            if (dt.getAttribute('data-sort') !== null) {
                let sort = parseInt(dt.getAttribute('data-sort'));
                options.columns = [
                    { select: sort, sort: "asc" }
                ];
            }
            if (dt.getAttribute('data-searchable') === 'false') {
                options.searchable = false;
            }
            if (dt.getAttribute('data-footer') === 'true') {
                options.footer = true;
            }

            new DataTable(dt, options);
        });

        // Automatically enable ckeditors that want to be replaced
        CKEDITOR.replaceAll(function(textarea, config) {
            // Make sure the textarea has 'ckeditor-replace'...
            if (!textarea.classList.contains('ckeditor-replace')) {
                return false;
            }

            config.contentCss = css;
            // config.filebrowserBrowserUrl = '';
        });

        // Left nav admin menu clicking
        document.querySelectorAll('.site-sidebar__menu li a').forEach(node => {
            node.addEventListener('click', e => {
                // How click the submenus open
                let animationSpeed = 300;

                // Get the clicked link and the next element
                let dropdown = node.nextElementSibling;
                if (dropdown === null) {
                    return;
                }

                //Check if the next element is a menu and is visible
                if (
                    dropdown.classList.contains('site-sidebar__submenu') &&
                    Utilities.isVisible(dropdown) &&
                    !document.body.classList.contains('sidebar-collapse')
                ) {
                    // Close the menu
                    dropdown.parentNode.classList.remove('active');
                    Velocity(dropdown, 'slideUp', {
                        duration: animationSpeed,
                        complete() {
                            dropdown.classList.remove('menu-open');
                        },
                        progress() {
                            // Window resize eventto recalculate page height
                            window.dispatchEvent(new Event('resize'));
                        },
                    });
                } else if (dropdown.classList.contains('site-sidebar__submenu') && !Utilities.isVisible(dropdown)) {
                    // Get the parent menu
                    const parentMenu = Utilities.getParents(node, 'ul')[0];

                    // Close all open menus within the parent
                    let ul = parentMenu.querySelectorAll('ul');
                    ul.forEach((item, idx) => {
                        // If it's visible, slide it up
                        if (Utilities.isVisible(item)) {
                            // Slide the menu up/closed
                            Velocity(item, 'slideUp', {
                                duration: animationSpeed,
                                progress() {
                                    // Window resize eventto recalculate page height
                                    window.dispatchEvent(new Event('resize'));
                                },
                            });

                            // Remove the menu-open class from the parent
                            item.classList.remove('menu-open');
                        }
                    });

                    // Open the target menu and add the menu-open class
                    Velocity(dropdown, 'slideDown', {
                        duration: animationSpeed,
                        complete() {
                            // Add the class active to the parent li (and remove it from all others)
                            dropdown.classList.add('menu-open');
                            parentMenu.querySelectorAll('li.active').forEach((item, idx) => {
                                item.classList.remove('active');
                            });
                            Utilities.getParents(node, 'li')[0].classList.add('active');
                        },
                        progress() {
                            // Window resize eventto recalculate page height
                            window.dispatchEvent(new Event('resize'));
                        },
                    });
                }

                //if this isn't a link, prevent the page from being redirected
                if (dropdown.classList.contains('site-sidebar__submenu')) {
                    e.preventDefault();
                }
            });
        });

        // Enable sidebar toggle
        document.querySelector('a.site-header__sidebar-toggle').addEventListener('click', e => {
            e.preventDefault();

            // Enable sidebar push menu
            if (window.innerWidth > 767) {
                document.body.classList.toggle('sidebar-collapse');
            } else {
                // Handle sidebar push menu for small screens
                if (document.body.classList.contains('sidebar-open')) {
                    document.body.classList.remove('sidebar-open', 'sidebar-collapse');
                } else {
                    document.body.classList.add('sidebar-open');
                }
            }
        });

        // Enable hide menu when clicking on the content-wrapper on small screens
        let main = document.querySelector('main');
        main.addEventListener('click', function() {
            if (window.innerWidth <= 767 && document.body.classList.contains('sidebar-open')) {
                document.body.classList.remove('sidebar-open');
            }
        });

        // When the window is resized we need to adjust wrapper sizes
        let header = document.querySelector('.site-header');
        let sidebar = document.querySelector('.site-sidebar__container');
        window.addEventListener('resize', () => {
            // Get various element heights
            const headerHeight = header.offsetHeight || 0;
            const sidebarHeight = sidebar.offsetHeight || 0;

            // Set the min-height of the content and sidebar based on the the height of the document.
            if (window.innerHeight >= sidebarHeight + headerHeight) {
                main.style.minHeight = `${window.innerHeight - headerHeight}px`;
            } else {
                main.style.minHeight = `${sidebarHeight}px`;
            }
        });
        window.dispatchEvent(new Event('resize'));
    }
});
